import type { DateRange } from "@daypicker/react"
import { formatPickerDate } from "../format"

type Props = {
    range?: DateRange
    postcodeRequired?: boolean
    disabled?: boolean
    activeDateField: "start" | "end" | null
    onSelect: (field: "start" | "end") => void
}

export function HireDateFields({ range, activeDateField, onSelect, postcodeRequired = false, disabled = false }: Props) {
    return <div className="ah-range-fields" role="group" aria-label="Delivery and collection date range">
        <button type="button" disabled={disabled} aria-disabled={postcodeRequired || undefined} className={activeDateField === "start" ? "is-active" : ""} aria-pressed={activeDateField === "start"} onClick={() => onSelect("start")}>
            <span className="ah-date-field-label">Delivery date</span>
            <strong>{formatPickerDate(range?.from)}</strong>
        </button>
        <button type="button" disabled={disabled} aria-disabled={postcodeRequired || undefined} className={activeDateField === "end" ? "is-active" : ""} aria-pressed={activeDateField === "end"} onClick={() => onSelect("end")}>
            <span className="ah-date-field-label">Collection date</span>
            <strong>{formatPickerDate(range?.to)}</strong>
        </button>
    </div>
}
